import { useEffect, useRef } from 'react';

type TimelinePlayheadProps = {
  totalDuration: number;
  inView: boolean;
  cycleKey: number;
};

export function TimelinePlayhead({ totalDuration, inView, cycleKey }: TimelinePlayheadProps) {
  const fillRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fill = fillRef.current;
    if (!fill) return;

    fill.style.transition = 'none';
    fill.style.width = '0%';
    void fill.offsetWidth;

    if (inView) {
      fill.style.transition = `width ${totalDuration}ms linear`;
      fill.style.width = '100%';
    }
  }, [totalDuration, inView, cycleKey]);

  return (
    <div className="tl-playhead-track" aria-hidden="true">
      <div ref={fillRef} className="tl-playhead-fill" />
    </div>
  );
}
